import Service from '../service';

export default class Lang {
    public value: any;

    constructor(public service: Service) { }

    public async set(lang: string) {
        const normalized = this.normalize(lang);
        this.value = normalized;
        this.updateDocumentLanguage(normalized);
        this.service.app.translate.use(normalized);
        await this.service.render();
    }

    public get() {
        return this.value;
    }

    public is(lang: string) {
        return this.value == lang;
    }

    public async translate(key: string) {
        let fn: any = () => new Promise((resolve) => {
            this.service.app.translate.get(key, { value: '' }).subscribe((res: string) => {
                resolve(res);
            });
        })
        return await fn();
    }

    private normalize(lang: string) {
        return ['ko', 'en'].includes(lang) ? lang : 'ko';
    }

    private updateDocumentLanguage(lang: string) {
        if (typeof document === 'undefined') return;

        const root = document.documentElement;
        root.lang = lang;
        root.setAttribute('translate', 'no');
        root.classList.add('notranslate');

        if (document.body) {
            document.body.setAttribute('translate', 'no');
            document.body.classList.add('notranslate');
        }
    }
}
